import React, { useContext, useEffect, useState, useRef } from "react";
import "../Styles/WeekelyTimesheet2.css";
import "../Styles/WeekelyTimesheet1.css";
import "../Styles/ContentWeek.css";
import "../Styles/Activitywise2.css";
import "../Styles/Userwise2.css";
import { UserContext } from "../context/UserContext";
import { AuthContext } from "../context/AuthContext";
import { CircularProgress } from "@mui/material";
import * as XLSX from "xlsx";
import "../Styles/Footerweek.css";
import { Info } from "@mui/icons-material";
import {
  clientApiUrl,
  taskApiUrl,
  notificationApiUrl,
  userApiUrl,
  reportApiUrl,
} from "../utils/GetUrl";
import ToastComponent from "./ToastComponent";
import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry } from "ag-grid-community";
import { ClientSideRowModelModule } from "ag-grid-community";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { validateYupSchema } from "formik";

function ActivityWise21({
  selectedDate,
  selectedEmployees,
  setProcessedData,
  selectedTeams,
  teams,
  setSelectedTeams,
  timeCode,
  selectedIds,
  selectedCostCenters,
  selectedTimeCode,
  setSelectedPrepareName,
  setSelsetSelectedClient,
}) {
  const [stdHoursData, setStdHoursData] = useState(null);

  const [totalTime, setTotalTime] = useState(0);
  const [difference, setDifference] = useState(0);
  const { teamsData, setTeamsData, setTeamNames, fetchTeams } =
    useContext(UserContext);
  const [userReport, setUserReport] = useState([]);
  const [timeCodes, setTimeCodes] = useState([]);
  const { token, logout } = useContext(AuthContext);
  const toastRef = useRef();
  const today = new Date();
  const defaultSelectedDate = selectedDate ? new Date(selectedDate) : today;
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);

  ModuleRegistry.registerModules([ClientSideRowModelModule]);

  const getStartDate = (dateString) => {
    const date = dateString ? new Date(dateString) : new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    return `${year}-${String(month).padStart(2, "0")}-01`;
  };

  useEffect(() => {
    const fetchStdHours = async () => {
      try {
        const response = await fetch(`${reportApiUrl}/GetHoursInReport`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await response.json();
        const parsedHours = parseFloat(data?.Result?.Hours);
        setStdHoursData(isNaN(parsedHours) ? 0 : parsedHours);
      } catch (error) {
        console.error("Error fetching stdHours:", error);
      }
    };

    if (token && reportApiUrl) {
      fetchStdHours();
    }
  }, [token, reportApiUrl]);

  const getEndDate = (dateString) => {
    const date = dateString ? new Date(dateString) : new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const lastDay = new Date(year, month, 0).getDate();
    return `${year}-${String(month).padStart(2, "0")}-${String(
      lastDay,
    ).padStart(2, "0")}`;
  };

  useEffect(() => {
    formatSelectedEmployees(selectedEmployees);
  }, [selectedEmployees, selectedTeams]);

  useEffect(() => {
    if (timeCode && Array.isArray(timeCode)) {
      // Filter out 9114 codes from the timeCodes array
      const uniqueCodes = [
        ...new Set(
          timeCode
            .filter((code) => {
              if (!code || code === null) {
                return false;
              }

              if (code.AL_Status === 0) {
                return false;
              }

              const salesforceCode = code.AL_SalseforceCode;
              if (!salesforceCode) {
                return false;
              }

              // Exclude blank / whitespace-only codes (they would render as
              // empty columns with no header and no data)
              const codeString = salesforceCode.toString().trim();
              if (!codeString) {
                return false;
              }

              if (
                codeString.startsWith("9114") ||
                codeString.startsWith("9000")
              ) {
                return false;
              }

              return true;
            })
            .map((code) => code.AL_SalseforceCode.toString().trim())
            .filter(Boolean), // Remove any undefined/null/blank values
        ),
      ];

      setTimeCodes(uniqueCodes);
    } else {
      setTimeCodes([]);
    }
  }, [timeCode]);

  const [holidays, setHolidays] = useState([]);
  const [monthlyHolidayCount, setMonthlyHolidayCount] = useState(0);

  const fetchHolidays = async (selectedYear) => {
    try {
      setLoading(true);
      const response = await fetch(
        `${clientApiUrl}/GetAllholiday?inputYear=${selectedYear}`,
        {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      if (response.status === 401) {
        toastRef.current.showToast(
          "Unauthorised access. Please login again.",
          "error",
        );
        await logout();
        return;
      }

      if (response.ok) {
        const data = await response.json();

        setHolidays(data); // 👈 store holidays
        setLoading(false);
      } else {
        toastRef.current.showToast("Failed to fetch holidays", "error");
      }
    } catch (error) {
      toastRef.current.showToast("Error fetching holidays", "error");
    }
  };

  useEffect(() => {
    if (token) {
      const currentYear = new Date().getFullYear();
      fetchHolidays(currentYear);
    }
  }, [token]);
  const countHolidaysForMonth = (holidayList, year, month) => {
    return holidayList.filter((h) => {
      const d = new Date(h.HL_Date);
      return d.getFullYear() === year && d.getMonth() === month;
    }).length;
  };
  useEffect(() => {
    if (holidays.length > 0) {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth(); // 0-based

      const count = countHolidaysForMonth(holidays, year, month);
      setMonthlyHolidayCount(count);
    }
  }, [holidays]);
  const fetchUserWise = async () => {
    setLoading(true);
    const startDate = getStartDate(selectedDate);
    const endDate = getEndDate(selectedDate);

    try {
      // CASE 1: Specific employees selected (via Preparer Name)
      if (selectedEmployees?.length > 0) {
        const emIds = selectedEmployees.map((emp) => emp.EM_ID).join(",");
        const url = `${taskApiUrl}/GetReportByEmId?dateRange1=${startDate}&dateRange2=${endDate}&EmpId=${emIds}`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const result = await response.json();

        let reportData = [];
        if (Array.isArray(result.Result)) {
          reportData = result.Result[0] || [];
        }

        const processedData = processActivityData(reportData);
        setUserReport(processedData);
      }
      // CASE 2: Teams selected
      else if (selectedTeams?.length > 0) {
        let url = `${taskApiUrl}/GetReportByEmId?dateRange1=${startDate}&dateRange2=${endDate}&TeamId=${selectedTeams.join(
          ",",
        )}`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const result = await response.json();

        let reportData = [];
        if (Array.isArray(result.Result)) {
          reportData = result.Result[0] || [];
        }

        const processedData = processActivityData(reportData);
        setUserReport(processedData);
      }
      // CASE 3: No filters (show all)
      else {
        let url = `${taskApiUrl}/GetReportByEmId?dateRange1=${startDate}&dateRange2=${endDate}`;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const result = await response.json();

        let reportData = [];
        if (Array.isArray(result.Result)) {
          reportData = result.Result[0] || [];
        }

        const processedData = processActivityData(reportData);
        setUserReport(processedData);
      }

      setInitialLoad(false);
    } catch (error) {
      console.error("Error fetching report:", error);
    } finally {
      setLoading(false);
    }
  };

  // Function to combine same activities for same EMID
  const processActivityData = (data) => {
    const activityMap = {};

    data.forEach((item) => {
      const key = `${item.EMID}_${item.Activity}`;

      if (!activityMap[key]) {
        activityMap[key] = {
          ...item,
          TotalRegisteredTime: Number(item.TotalRegisteredTime || 0),
          NonBillableTime: Number(item.NonBillableTime || 0),
        };
      } else {
        activityMap[key].TotalRegisteredTime += Number(
          item.TotalRegisteredTime || 0,
        );
        activityMap[key].NonBillableTime += Number(item.NonBillableTime || 0);
      }
    });

    return Object.values(activityMap);
  };

  useEffect(() => {
    if (!token) return;
    fetchUserWise();
  }, [selectedDate, selectedTeams, token, selectedEmployees]);

  const formatSelectedEmployees = (selected) => {
    if (!selected) return "";
    const emIds = selected?.map((item) => item["EM_ID"]);
    return emIds?.join(",");
  };

  const getWorkingDays = (start, end) => {
    const date = new Date(start);
    const endDate = new Date(end);
    let count = 0;

    while (date <= endDate) {
      const day = date.getDay();
      if (day !== 0 && day !== 6) count++;
      date.setDate(date.getDate() + 1);
    }

    return count;
  };

  const { teamNames, usersList } = useContext(UserContext);

  const processUserReport = (userReport) => {
    if (!usersList || usersList.length === 0) return [];

    // Get date range for working days calculation
    const startDate = getStartDate(selectedDate);
    const endDate = getEndDate(selectedDate);

    // Create a map to store employee data
    const employeeMap = {};

    // Initialize all relevant employees first
    let employeesToShow = [];

    if (selectedEmployees?.length > 0) {
      employeesToShow = usersList.filter((user) =>
        selectedEmployees.some((emp) => emp.EM_ID === user.EM_ID),
      );
    } else if (selectedTeams?.length > 0) {
      employeesToShow = usersList.filter((user) =>
        selectedTeams.includes(Number(user.STM_Team)),
      );
    } else {
      employeesToShow = usersList;
    }

    employeesToShow.forEach((user) => {
      const emId = user.EM_ID;
      const workingDays = getWorkingDays(startDate, endDate);
      const synergyHours = workingDays * stdHoursData;

      employeeMap[emId] = {
        emId,
        emName: `${user.EM_FirstName} ${user.EM_LastName}`,
        emTeam:
          teamNames?.find((t) => t.id == user.STM_Team)?.name ||
          "Unassigned Team",
        emTotalTime: 0,
        emSynergyHours: synergyHours,
        emDiff: synergyHours,
        // Initialize all time codes to 0 (case-insensitive keys)
        internal9000Billable: 0,
        internal9114NonBillable: 0,
        ...timeCodes.reduce((acc, code) => {
          // Store the code in uppercase for consistent comparison
          const normalizedCode = code?.toString().toUpperCase();
          return normalizedCode ? { ...acc, [normalizedCode]: 0 } : acc;
        }, {}),
      };
    });

    // Now populate with actual data from the report
    userReport.forEach((task) => {
      const emId = task.EMID;
      const activity = task.Activity;
      const totalTime = Number(task.TotalRegisteredTime || 0);
      const nonBillable = Number(task.NonBillableTime || 0);

      if (!employeeMap[emId]) return;

      // Normalize activity for case-insensitive comparison
      const normalizedActivity = activity?.toUpperCase();

      // ✅ 9000 Internal work (aggregate across ALL dates)
      if (normalizedActivity === "9000 INTERNAL WORK") {
        employeeMap[emId].internal9000Billable += totalTime;
        employeeMap[emId].internal9114NonBillable += nonBillable;
      }
      // ✅ All OTHER activities (non-9000, non-9114)
      else if (
        normalizedActivity &&
        !normalizedActivity.startsWith("9000") &&
        !normalizedActivity.startsWith("9114")
      ) {
        // Use normalized activity as key
        employeeMap[emId][normalizedActivity] =
          (employeeMap[emId][normalizedActivity] || 0) + totalTime;
      }

      // ✅ Totals must include EVERYTHING (even 9000 rows with 0 total)
      employeeMap[emId].emTotalTime += totalTime;
    });

    Object.values(employeeMap).forEach((emp) => {
      // Sum middle scroll columns - use normalized timeCodes
      const middleSum = timeCodes.reduce((sum, code) => {
        const normalizedCode = code?.toString().toUpperCase();
        return sum + (Number(emp[normalizedCode]) || 0);
      }, 0);

      // Sum right-side first two columns
      const rightSum =
        (Number(emp.internal9000Billable) || 0) +
        (Number(emp.internal9114NonBillable) || 0);

      // ✅ Final total = middle + right
      emp.emTotalTime = middleSum + rightSum;

      // ✅ Difference
      emp.emDiff = emp.emSynergyHours - emp.emTotalTime;
    });

    return Object.values(employeeMap);
  };

  const processedUserReport = processUserReport(userReport);

  const tttime = processedUserReport?.reduce(
    (acc, curr) => acc + curr.emTotalTime,
    0,
  );
  const ttdiff = processedUserReport?.reduce(
    (acc, curr) => acc + curr.emDiff,
    0,
  );

  useEffect(() => {
    if (!loading) {
      setDifference(ttdiff ? ttdiff.toFixed(2) : 0);
      setTotalTime(tttime ? tttime.toFixed(2) : 0);
    }
  }, [loading]);

  const leftPinnedColumns = [
    {
      headerName: "EMPLOYEE",
      field: "emName",
      pinned: "left",
      width: 260,
      cellStyle: { display: "flex" },
      headerClass: "content-user-2",
      suppressMovable: true,
    },
    {
      headerName: "TEAM",
      field: "emTeam",
      pinned: "left",
      width: 260,
      headerClass: "content-user-line",
      suppressMovable: true,
    },
  ];

  const centerColumns = timeCodes.map((code) => {
    const normalizedCode = code?.toString().toUpperCase();
    return {
      headerName: code, // Display the original code
      field: normalizedCode, // Use normalized code as field name
      width: 500,
      valueFormatter: ({ value }) =>
        value ? Number(value).toFixed(2) : "0.00",
      cellClass: "content-user-date",
      headerClass: "table-title-twos",
      minWidth: 300,
      flex: 1,
      headerComponentParams: {
        menuIcon: "fa fa-bars",
      },
    };
  });

  const rightPinnedColumns = [
    {
      headerName: "9000 internal billable",
      field: "internal9000Billable",
      pinned: "right",
      width: 170,
      valueFormatter: ({ value }) => value?.toFixed(2) || "0.00",
      headerClass: "content-user-before",
    },
    {
      headerName: "9114 Synergy Internal time",
      field: "internal9114NonBillable",
      pinned: "right",
      width: 170,
      valueFormatter: ({ value }) => value?.toFixed(2) || "0.00",
      headerClass: "content-user-before",
    },
    {
      headerName: "Total Reported Hours in VF",
      field: "emTotalTime",
      pinned: "right",
      width: 170,
      valueFormatter: ({ value }) => value?.toFixed(2) || "0.00",
    },
    {
      headerName: "Total Synergy Hours",
      field: "emSynergyHours",
      pinned: "right",
      width: 170,
      valueFormatter: ({ value }) => value?.toFixed(2) || "0.00",
    },

    {
      headerName: "DIFFERENCE",
      field: "emDiff",
      pinned: "right",
      width: 150,
      valueFormatter: ({ value }) => value?.toFixed(2) || "0.00",
    },
  ];

  const columnDefs = [
    ...leftPinnedColumns,
    ...centerColumns,
    ...rightPinnedColumns,
  ];

  const [headerHeight, setHeaderHeight] = useState(50);
  const [rowHeight, setRowHeight] = useState(30);

  useEffect(() => {
    const updateGridSize = () => {
      if (window.innerWidth >= 1920) {
        setHeaderHeight(65);
        setRowHeight(40);
      } else if (window.innerWidth >= 1440) {
        setHeaderHeight(65);
        setRowHeight(35);
      } else {
        setHeaderHeight(65);
        setRowHeight(30);
      }
    };

    updateGridSize();
    window.addEventListener("resize", updateGridSize);
    return () => window.removeEventListener("resize", updateGridSize);
  }, []);

  // In ActivityWise21.js, update the useEffect that processes the data:
  useEffect(() => {
    const processed = processUserReport(userReport);
    setProcessedData(processed); // This sends data back to parent
  }, [userReport, usersList, teamNames, selectedDate, stdHoursData, timeCodes]);

  return (
    <>
      <ToastComponent ref={toastRef} timeout={4000} />
      {loading && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <CircularProgress style={{ color: "purple" }} width={40} />
        </div>
      )}
      {!loading && (
        <div
          className="ag-theme-alpine ag-scroll-wrapper"
          style={{
            height: "75vh",
            width: "100%",
            padding: "20px",
          }}
        >
          <AgGridReact
            rowData={processedUserReport}
            columnDefs={columnDefs}
            headerHeight={headerHeight}
            rowHeight={rowHeight}
            suppressHorizontalScroll={false}
            domLayout="normal"
            defaultColDef={{
              resizable: true,
              sortable: true,
              flex: 1,
              minWidth: 120,
            }}
            getRowStyle={({ node }) => ({
              backgroundColor:
                node.rowIndex % 2 === 0 ? "rgba(241, 241, 241, 1)" : "white",
            })}
          />
        </div>
      )}
    </>
  );
}

export default ActivityWise21;
